import { colors, typography } from '../styles/theme';

export const ADMIN_SURFACE = colors.backgroundSurface;
export const ADMIN_RAIL = colors.backgroundDark;
export const ADMIN_ROW_BORDER = '#383838';

export function formatAdminDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' });
}

export function shortUserId(userId) {
  const value = String(userId || '').trim();
  if (!value) return '—';
  if (value.length <= 18) return value;
  return `${value.slice(0, 8)}…${value.slice(-6)}`;
}

export const adminFieldSx = {
  '& .MuiInputLabel-root': {
    color: colors.textSecondary,
    fontFamily: typography.fontFamily.primary,
  },
  '& .MuiInputLabel-root.Mui-focused': { color: colors.primary },
  '& .MuiOutlinedInput-root': {
    backgroundColor: colors.backgroundDark,
    borderRadius: '8px',
    color: colors.textPrimary,
    fontFamily: typography.fontFamily.primary,
    fontSize: '14px',
    '& fieldset': { borderColor: colors.border },
    '&:hover fieldset': { borderColor: colors.border },
    '&.Mui-focused fieldset': { borderColor: colors.primary },
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: typography.fontFamily.primary,
    fontSize: '14px',
  },
};

export const adminSelectMenuProps = {
  PaperProps: {
    sx: {
      bgcolor: colors.backgroundDark,
      color: colors.textPrimary,
      border: `1px solid ${colors.border}`,
      '& .MuiMenuItem-root': {
        fontFamily: typography.fontFamily.primary,
        fontSize: '14px',
      },
      '& .MuiMenuItem-root:hover': {
        bgcolor: colors.backgroundSurface,
      },
      '& .Mui-selected': {
        bgcolor: 'rgba(72,146,145,0.18)',
      },
    },
  },
};

export const adminSelectSx = {
  ...adminFieldSx,
  minWidth: 140,
};

export const adminMutedSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '13px',
  lineHeight: '18px',
  color: 'rgba(255,255,255,0.45)',
};

export const adminMonoSx = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  fontSize: '13px',
  color: 'rgba(255,255,255,0.82)',
  wordBreak: 'break-all',
};

export const adminRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  px: 2,
  py: 1.5,
  borderBottom: `1px solid ${ADMIN_ROW_BORDER}`,
  '&:last-of-type': { borderBottom: 'none' },
};

export const adminSectionTitleSx = {
  fontFamily: typography.fontFamily.heading,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '16px',
  lineHeight: '20px',
  color: colors.textPanelTitle,
  m: 0,
  mb: 1.5,
};

export const adminCardSx = {
  borderRadius: '10px',
  border: `1px solid ${ADMIN_ROW_BORDER}`,
  bgcolor: ADMIN_SURFACE,
  overflow: 'hidden',
};

export const adminPageSx = {
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
};

export const adminPageToolbarSx = {
  flexShrink: 0,
};

export const adminScrollRegionSx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const adminScrollPanelSx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const adminScrollCardSx = {
  ...adminCardSx,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const adminScrollBodySx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
};

export const adminScrollFooterSx = {
  flexShrink: 0,
  borderTop: `1px solid ${ADMIN_ROW_BORDER}`,
};

export const adminFormRowSx = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1.5,
  mb: 2,
  alignItems: 'flex-start',
};

export const adminPrimaryButtonSx = {
  textTransform: 'none',
  borderRadius: '8px',
  minHeight: 40,
  height: 40,
  px: 2.25,
  fontSize: '14px',
  fontWeight: typography.fontWeight.semibold,
  fontFamily: typography.fontFamily.primary,
  color: colors.backgroundLight,
  bgcolor: colors.primary,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: colors.primaryHover,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: colors.primaryLight,
    color: colors.backgroundLight,
    opacity: 0.45,
  },
};

export const adminSecondaryButtonSx = {
  textTransform: 'none',
  borderRadius: '8px',
  minHeight: 40,
  height: 40,
  px: 2,
  fontSize: '14px',
  fontWeight: typography.fontWeight.medium,
  fontFamily: typography.fontFamily.primary,
  color: colors.textPanelDescription,
  border: `1px solid ${colors.border}`,
  bgcolor: 'transparent',
  boxShadow: 'none',
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.06)',
    borderColor: colors.border,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    color: colors.textSecondary,
    borderColor: colors.border,
    bgcolor: 'transparent',
    opacity: 1,
  },
};

export const adminDangerButtonSx = {
  ...adminSecondaryButtonSx,
  color: colors.error,
  borderColor: colors.error,
  '&:hover': {
    bgcolor: 'rgba(242,184,181,0.08)',
    borderColor: colors.error,
  },
};
